import { createSlice } from "@reduxjs/toolkit";
import {
  getJobPosts,
  getJobPostsStats,
  addNewJobPost,
  updateJobPost,
  updateJobPostStatus,
  deleteJobPost,
} from "./thunk";

export const initialState = {
  jobPosts: [],
  stats: { total: 0, open: 0, expired: 0, closed: 0, cancelled: 0 },
  isLoading: false,
  isStatsLoading: false,
  error: null,
};

const jobPostsSlice = createSlice({
  name: "jobposts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // getJobPosts
    builder.addCase(getJobPosts.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getJobPosts.fulfilled, (state, action) => {
      state.isLoading = false;
      state.jobPosts = action.payload || [];
    });
    builder.addCase(getJobPosts.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    // getJobPostsStats
    builder.addCase(getJobPostsStats.pending, (state) => {
      state.isStatsLoading = true;
    });
    builder.addCase(getJobPostsStats.fulfilled, (state, action) => {
      state.isStatsLoading = false;
      state.stats = action.payload || initialState.stats;
    });
    builder.addCase(getJobPostsStats.rejected, (state) => {
      state.isStatsLoading = false;
    });

    // addNewJobPost
    builder.addCase(addNewJobPost.fulfilled, (state, action) => {
      state.jobPosts = [action.payload, ...state.jobPosts];
    });

    // updateJobPost
    builder.addCase(updateJobPost.fulfilled, (state, action) => {
      state.jobPosts = state.jobPosts.map((j) =>
        j._id === action.payload._id ? action.payload : j
      );
    });

    // updateJobPostStatus
    builder.addCase(updateJobPostStatus.fulfilled, (state, action) => {
      state.jobPosts = state.jobPosts.map((j) =>
        j._id === action.payload._id ? action.payload : j
      );
    });

    // deleteJobPost
    builder.addCase(deleteJobPost.fulfilled, (state, action) => {
      state.jobPosts = state.jobPosts.filter(
        (j) => j._id !== action.payload.id
      );
    });
  },
});

export default jobPostsSlice.reducer;
